
import { useState } from "react";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { useAppSelector } from "@/redux/store";
import { RootState } from "@/redux/store";

export const Layout: React.FC<{
    children?: React.ReactNode;
}> = ({ children }) => {
    const { collapsed } = useAppSelector((state: RootState) => state.user);
    const [mobileOpen, setMobileOpen] = useState<boolean>(false);

    return (
        <div className="flex h-screen bg-background">
            <Sidebar mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />
            {mobileOpen && <div className="fixed inset-0 bg-black/50 z-5 md:hidden" onClick={() => setMobileOpen(false)} />}
            <div
                className={`flex-1 flex flex-col min-w-0 transition-all duration-300 ${collapsed ? "md:ms-20" : "md:ms-64"}`}
            >
                <Header mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />

                <main className="flex-1 px-4 md:px-6 py-6">{children}</main>
            </div>
        </div>
    );
};
